import React, { useState, useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Menu, X, Sun, Moon } from 'lucide-react';
import { ThemeContext } from '../../context/ThemeContext';

const Header = ({ setActiveTab }) => {

  const navigate = useNavigate();

  const handleLogoClick = () => {
    if (setActiveTab) {
      setActiveTab('experience');
    }
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const [menuOpen, setMenuOpen] = useState(false);
  const { theme, toggleTheme } = useContext(ThemeContext);

  const handleNavigation = useCallback((targetId) => {
    setMenuOpen(false);
    setActiveTab(targetId);
  }, [setActiveTab]);

  const navItems = [
    { name: 'Experience', target: 'experience' },
    { name: 'Skills', target: 'skills' },
    { name: 'Innovations', target: 'innovations' },
    { name: 'Contact', target: 'contact' },
    { name: 'Blog', target: 'blog' }
  ];

  return (
    <header className="bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-600 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 text-white fixed top-0 w-full z-50 shadow-md transition-colors duration-300" style={{ height: '70px' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex justify-between items-center">
        <h1
          className="text-2xl md:text-3xl font-extrabold cursor-pointer hover:text-gray-300 transition duration-300"
          onClick={handleLogoClick}
        >
          Gulshan Kumar
        </h1>

        <div className="flex items-center gap-4">
          {/* Theme Toggle (Desktop) */}
          <button
            onClick={toggleTheme}
            className="hidden md:block p-2 rounded-full hover:bg-white/10 transition-colors"
            aria-label="Toggle theme"
          >
            {theme === 'dark' ? <Sun size={24} /> : <Moon size={24} />}
          </button>

          {/* Hamburger Icon (mobile only) */}
          <div className="md:hidden flex items-center gap-4">
            <button
              onClick={toggleTheme}
              className="p-2 rounded-full hover:bg-white/10 transition-colors"
              aria-label="Toggle theme"
            >
              {theme === 'dark' ? <Sun size={24} /> : <Moon size={24} />}
            </button>
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="text-white focus:outline-none"
              aria-label="Toggle menu"
            >
              {menuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-6">
            {navItems.map((item) => (
              <motion.li
                key={item.target}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                className="list-none cursor-pointer"
              >
                <button
                  onClick={() => handleNavigation(item.target)}
                  className="hover:text-gray-300 transition duration-300"
                >
                  {item.name}
                </button>
              </motion.li>
            ))}
          </nav>
        </div>
      </div>

      {/* Mobile Navigation */}
      {menuOpen && (
        <div className="md:hidden bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-600 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 px-6 pb-4 pt-2 absolute top-[70px] left-0 w-full z-20 shadow-lg transition-colors duration-300">
          <ul className="space-y-4">
            {navItems.map((item) => (
              <motion.li
                key={item.target}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="list-none cursor-pointer"
              >
                <button
                  onClick={() => handleNavigation(item.target)}
                  className="block text-white text-lg hover:text-gray-300 transition duration-300"
                >
                  {item.name}
                </button>
              </motion.li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
};

export default Header;
